import useSWR from 'swr';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { useCurrentSession } from '@components/hooks';
import { map } from 'lodash';
import { distinctNames, GeoItem } from '@v2/components/campaign/GeoTargeter';
import { Country } from '@local-types/country';

export const useCountries = () => {
  const { apiIsReady, getTargeting } = useCurrentSession();
  const { releaseCountryTargeting: shouldLoadCountries } = useFlags();

  const url = 'countries/';

  const fetcher = ({ url }: { url: string }): Promise<GeoItem[]> =>
    getTargeting(url).then(res =>
      map(res.data.results, (country: Country) => ({
        id: country.country_code_3,
        name: country.name,
        text: country.name,
        type: 'country' as (typeof distinctNames)[keyof typeof distinctNames],
      }))
    );

  return useSWR(apiIsReady && shouldLoadCountries ? { url } : null, fetcher);
};
